import { message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { DocumentTemplateDetailCard } from "./components/DocumentTemplateDetailCard";
import {
  deleteDocumentTemplateById,
  fetchDocumentTemplateById,
} from "@/lib/api/resources/documentTemplate";

export const DocumentTemplateDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const documentTemplateQuery = useQuery({
    queryKey: ["documentTemplate", id],
    queryFn: () => fetchDocumentTemplateById(id),
  });

  const deleteDocumentTemplateMutation = useMutation({
    mutationFn: () => deleteDocumentTemplateById(id),
    onSuccess: () => {
      navigate(`/document-templates`);
      message.success("Document template succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de document template",
      ),
  });

  return (
    <DocumentTemplateDetailCard
      deleteMutation={deleteDocumentTemplateMutation}
      documentTemplate={documentTemplateQuery.data}
      isLoading={documentTemplateQuery.isLoading}
    />
  );
};
